/*
 * The texts of the events extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		event: {
			create: 'Veranstaltung anlegen',
			edit: 'Veranstaltung bearbeiten',
			settings: 'Veranstaltungs-Einstellungen',
			enable: 'Veranstaltung freischalten',
			lock: 'Veranstaltung sperren',
		},
		// The teams of an event, in its settings
		event_team: {
			add: 'Team hinzufügen',
			remove: 'Team entfernen',
		},
	},
	pages: {
		admin: {
			events: {
				title: 'Events',
				create: 'Event erstellen',
				edit: 'Event bearbeiten',
				teams: 'Teams',
			},
		},
		settings: {
			events: {
				title: 'Events',
			},
		},
	},
	sidebar: {
		events: 'Events',
	},
	modals: {
		admin: {
			edit_event: {
				create: 'Neues Event erstellen',
				edit: 'Event bearbeiten',
				users: 'Personen',
				teams: 'Teams',
			},
		},
		invite_team: {
			title: 'Team hinzufügen',
		},
	},
	data: {
		event: {
			id: 'Id',
			name: 'Name',
			prefix: 'Präfix',
			start_at: 'Start',
			end_at: 'Ende',
			show_start_at: 'Start der Veranstaltung',
			show_end_at: 'Ende der Veranstaltung',
			is_locked: 'Gesperrt',
			enabled: 'Aktiv',
			status: 'Status',
			teams_count: '# Teams',
			users_count: '# Personen',
			preferred_crs: 'Bevorzugtes Koordinatensystem',
			coordinates: 'Koordinaten',
			inital_coordinates: 'Start Koordinaten',
		},
	},
	notifications: {
		assigned_to_event: {
			icon: 'fa-campground',
			title: 'Zu Veranstaltung hinzugefügt',
			text: "Du wurdest zur Veranstaltung '{event_name}' hinzugefügt.",
		},
	},
	enums: {
		event_state: {
			active: 'Aktiv',
			inactive: 'Inaktiv',
		},
	},
	components: {
		// The switcher's group of the user's other records of this kind
		header_context: {
			own_event: 'Weitere Veranstaltungen',
		},
		// efOccupiedDaysNote
		occupied_days: {
			note: 'Vom {first} bis {last} hängt schon etwas an der Veranstaltung. Der Zeitraum muss diese Tage einschließen.',
		},
	},
	contexts: {
		event: 'Veranstaltung',
	},
	tabs: {
		context_settings: {
			teams: 'Teams',
			events: 'Events',
		},
	},
	confirms: {
		remove_team_from_event: {
			title: 'Team entfernen',
			text: "Soll das Team '{team}' nicht mehr an '{event}' teilnehmen?",
		},
	},
};
